const Data = [
    {
    id : 1,
    title :"Online Voting System",
    content:"The Online Voting System project aims to provide a convenient and secure platform for conducting elections or polls through the internet. It allows eligible voters to cast their votes remotely, eliminating the need for physical polling stations and enabling a more inclusive and accessible voting process.",
    img:"/images/vote.jpg",
    category:"Desktop Projects"
},

{
    id : 2,
    title :"Hospital Managment System(HMS)",
    content:"The Hospital Management System is a comprehensive software solution designed to streamline and automate various administrative and operational processes within a healthcare facility. It aims to improve the efficiency, accuracy, and overall quality of patient care while enhancing the management of hospital resources.",
    category:"Web Projects",
    img:"/images/hms.png",
},
{
    id : 3,
    title :"Point Of Sale",
    content:"The Point of Sale (POS) System is a software and hardware solution that enables businesses to efficiently process customer transactions, manage inventory, and streamline sales operations.",
    category:"Web Projects",
    img:"/images/pos.jpeg",
},
];

export default Data;